 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"callUs":"callUs","chatbot":"chatbot","chatbot-cat-data~chatbot-cats":"chatbot-cat-data~chatbot-cats","chatbot-cats":"chatbot-cats","chatbot-cat-data~chatbot-delivery~chatbot-items~reply":"chatbot-cat-data~chatbot-delivery~chatbot-items~reply","chatbot-items":"chatbot-items","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings~reply~reply_browse":"chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings~reply~reply_browse","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings":"chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings","chatbot-cat-data":"chatbot-cat-data","chatbot-item-data":"chatbot-item-data","chatbot-settings":"chatbot-settings","chatbot-delivery~chatbot-init~chatbot-insihgts~notifications~reply~reply_browse":"chatbot-delivery~chatbot-init~chatbot-insihgts~notifications~reply~reply_browse","chatbot-delivery":"chatbot-delivery","reply~reply_browse":"reply~reply_browse","reply":"reply","chatbot-init":"chatbot-init","reply_browse":"reply_browse","chatbot-insihgts":"chatbot-insihgts","notifications":"notifications","control":"control","documentation":"documentation","manage":"manage","manage-addpage":"manage-addpage","manage-browsepages":"manage-browsepages","selectpage":"selectpage"}[chunkId]||chunkId) + "." + {"callUs":"91b1a452","chatbot":"60f333d4","chatbot-cat-data~chatbot-cats":"4b0b46b6","chatbot-cats":"7c36eae5","chatbot-cat-data~chatbot-delivery~chatbot-items~reply":"1c6f0c17","chatbot-items":"9deec334","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings~reply~reply_browse":"b7f9c6b6","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings":"a52ed84d","chatbot-cat-data":"6b3f277e","chatbot-item-data":"d18e476d","chatbot-settings":"bb9f93e7","chatbot-delivery~chatbot-init~chatbot-insihgts~notifications~reply~reply_browse":"56d5e870","chatbot-delivery":"8b4be296","reply~reply_browse":"7a1f1f61","reply":"d285d334","chatbot-init":"2a9d2e2c","reply_browse":"a24ec4f5","chatbot-insihgts":"d923f3c7","notifications":"d0a78748","chunk-16d06c50":"97a41b30","chunk-190492d4":"58010321","chunk-1c2d75a4":"406c208f","chunk-3de9ce58":"ad13b72d","chunk-7d5e0d7e":"ffe2c144","control":"6691250d","documentation":"142267e0","manage":"71349d74","manage-addpage":"1310c6e0","manage-browsepages":"e91a1ea7","selectpage":"1d32730c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"callUs":1,"chatbot":1,"chatbot-cats":1,"chatbot-items":1,"chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings":1,"chatbot-cat-data":1,"chatbot-item-data":1,"chatbot-settings":1,"chatbot-delivery":1,"reply~reply_browse":1,"reply":1,"chatbot-init":1,"reply_browse":1,"chatbot-insihgts":1,"notifications":1,"chunk-16d06c50":1,"chunk-190492d4":1,"chunk-1c2d75a4":1,"chunk-3de9ce58":1,"chunk-7d5e0d7e":1,"documentation":1,"manage":1,"manage-addpage":1,"manage-browsepages":1,"selectpage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"callUs":"callUs","chatbot":"chatbot","chatbot-cat-data~chatbot-cats":"chatbot-cat-data~chatbot-cats","chatbot-cats":"chatbot-cats","chatbot-cat-data~chatbot-delivery~chatbot-items~reply":"chatbot-cat-data~chatbot-delivery~chatbot-items~reply","chatbot-items":"chatbot-items","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings~reply~reply_browse":"chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings~reply~reply_browse","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings":"chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings","chatbot-cat-data":"chatbot-cat-data","chatbot-item-data":"chatbot-item-data","chatbot-settings":"chatbot-settings","chatbot-delivery~chatbot-init~chatbot-insihgts~notifications~reply~reply_browse":"chatbot-delivery~chatbot-init~chatbot-insihgts~notifications~reply~reply_browse","chatbot-delivery":"chatbot-delivery","reply~reply_browse":"reply~reply_browse","reply":"reply","chatbot-init":"chatbot-init","reply_browse":"reply_browse","chatbot-insihgts":"chatbot-insihgts","notifications":"notifications","control":"control","documentation":"documentation","manage":"manage","manage-addpage":"manage-addpage","manage-browsepages":"manage-browsepages","selectpage":"selectpage"}[chunkId]||chunkId) + "." + {"callUs":"04fa79e2","chatbot":"e98aeb3d","chatbot-cat-data~chatbot-cats":"31d6cfe0","chatbot-cats":"4486f26b","chatbot-cat-data~chatbot-delivery~chatbot-items~reply":"31d6cfe0","chatbot-items":"ab2a1a66","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings~reply~reply_browse":"31d6cfe0","chatbot-cat-data~chatbot-init~chatbot-item-data~chatbot-settings":"a30140f7","chatbot-cat-data":"ab491050","chatbot-item-data":"248363cd","chatbot-settings":"6dc26019","chatbot-delivery~chatbot-init~chatbot-insihgts~notifications~reply~reply_browse":"31d6cfe0","chatbot-delivery":"edd05904","reply~reply_browse":"7717f900","reply":"8668e994","chatbot-init":"81effd60","reply_browse":"6c060d4a","chatbot-insihgts":"5320a37c","notifications":"67c9d67b","chunk-16d06c50":"2f30eddc","chunk-190492d4":"5195641a","chunk-1c2d75a4":"61dac8ab","chunk-3de9ce58":"aa31a519","chunk-7d5e0d7e":"57795afd","control":"31d6cfe0","documentation":"2ddfe8a9","manage":"1f771e26","manage-addpage":"10b442cf","manage-browsepages":"47b11bc7","selectpage":"dcc14fa2"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
